var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex justify-between q-px-md",class:{'blue': _vm.color == 'blue', 'white': _vm.color == 'white'}},[_c('span',[_vm._v(" "+_vm._s(_vm.btnName)+" ")]),_c('span',[_c('q-icon',{attrs:{"name":"chevron_right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }